import { defineComponent as C, openBlock as t, createElementBlock as r, createVNode as d, unref as e, withCtx as a, createTextVNode as n, toDisplayString as l, Fragment as g, renderList as _, createBlock as h, normalizeClass as k, normalizeStyle as v } from "vue";
import y from "./ghl-ui.es235.js";
import "./ghl-ui.es23.js";
import "./ghl-ui.es50.js";
import "./ghl-ui.es13.js";
import x from "./ghl-ui.es126.js";
import B from "./ghl-ui.es132.js";
import S from "./ghl-ui.es127.js";
import $ from "./ghl-ui.es72.js";
const w = { class: "brand-color-header-content" }, I = {
  key: 0,
  class: "brand-color-swatches"
}, T = ["onClick"], U = {
  key: 1,
  class: "brand-color-swatches"
}, z = C({
  __name: "BrandColors",
  props: {
    brandColors: {
      type: Array,
      default: () => []
    },
    value: {
      type: String
    }
  },
  emits: ["update:value", "route:brand-boards"],
  setup(i, { emit: b }) {
    const c = b, s = y("BrandColorPicker");
    return (f, u) => {
      var m;
      return t(), r("div", w, [
        d(e(x), { style: { padding: "0 16px" } }, {
          default: a(() => [
            n(l(`${e(s).brandColors}`), 1)
          ]),
          _: 1
        }),
        ((m = i.brandColors) == null ? void 0 : m.length) > 0 ? (t(), r("div", I, [
          (t(!0), r(g, null, _(f.$props.brandColors, (o, p) => (t(), h(e(B), { key: p }, {
            trigger: a(() => [
              (t(), r("div", {
                key: p,
                class: k(["brand-color-swatch-item", { active: o.hexa.toString() === i.value }]),
                style: v({ backgroundColor: o.hexa.toString() }),
                onClick: (N) => c("update:value", o.hexa)
              }, null, 14, T))
            ]),
            default: a(() => [
              n(" " + l(o.label), 1)
            ]),
            _: 2
          }, 1024))), 128))
        ])) : (t(), r("div", U, [
          d(e(S), null, {
            default: a(() => [
              n(l(`${e(s).noBrandColors}`), 1)
            ]),
            _: 1
          }),
          d(e($), {
            id: "brand-board-get-started-btn",
            onClick: u[0] || (u[0] = (o) => c("route:brand-boards")),
            text: ""
          }, {
            default: a(() => [
              n(l(`${e(s).getStarted}`), 1)
            ]),
            _: 1
          })
        ]))
      ]);
    };
  }
}), j = z;
export {
  j as default
};
